import { action } from "typesafe-actions";

import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import { showMessage } from "../messages/messagesActions";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IActionEvent, IChatbotContact } from "./chatbot.types";

export const FETCH_CONTACT_LIST_PROGRESS = "FETCH_CONTACT_LIST_PROGRESS";
export const FETCH_CONTACT_LIST_SUCCESS = "FETCH_CONTACT_LIST_SUCCESS";
export const FETCH_CONTACT_LIST_FAILED = "FETCH_CONTACT_LIST_FAILED";
export const FETCH_CONTACT_LIST_WHATSAPP_NOT_SCANNED =
  "FETCH_CONTACT_LIST_WHATSAPP_NOT_SCANNED";
export const FETCH_CONTACT_LIST_WHATSAPP_SERVICE_OFF =
  "FETCH_CONTACT_LIST_WHATSAPP_SERVICE_OFF";

export const fetchContactListProgress = () =>
  action(FETCH_CONTACT_LIST_PROGRESS);
export const fetchContactListSuccess = (
  data: IChatbotContact[],
  totalRecords: number
) =>
  action(FETCH_CONTACT_LIST_SUCCESS, {
    data,
    totalRecords,
  });
export const fetchContactListFailed = () => action(FETCH_CONTACT_LIST_FAILED);
export const fetchContactListWhatsAppNotScanned = () =>
  action(FETCH_CONTACT_LIST_WHATSAPP_NOT_SCANNED);
export const fetchContactListWhatsAppServiceOff = () =>
  action(FETCH_CONTACT_LIST_WHATSAPP_SERVICE_OFF);

export const fetchContactListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    company_outlet_uuid: string,
    whatsapp_web_service: boolean,
    date: IDataTableV2DateState["dates"],
    recipient_number?: string,
    whatsappFilters?: string[]
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchContactListProgress());

      let url = `/conversation/get-contacts?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&company_outlet_uuid=${company_outlet_uuid}&whatsapp_web_service=${whatsapp_web_service}`;
      if (date.fromDate) {
        url += `&from_date=${date.fromDate}`;
      }
      if (date.toDate) {
        url += `&to_date=${date.toDate}`;
      }
      if (recipient_number) {
        url += `&columns=recipient_number,recipient_name&value=${recipient_number}`;
      }
 
      if (whatsappFilters && whatsappFilters.length > 0) {
        whatsappFilters.forEach((filter) => {
          url += `&whatsapp_filters=${encodeURIComponent(filter)}`;
        });
      }

      const res = await api.get(url);

      const previousState = getState().chatbot.contactList.list;

      const data: IChatbotContact[] = res.data.data;
      const totalRecords = res.data.totalRecords || data.length; // Fallback to data length if totalRecords not provided
      dispatch(
        fetchContactListSuccess([...previousState, ...data], totalRecords)
      );
    } catch (err: any) {
      const errorMessage = err?.response?.data?.message;

      // Check if the error is specifically about WhatsApp not being scanned
      if (errorMessage === "Whatsapp is not scanned") {
        dispatch(fetchContactListWhatsAppNotScanned());
        // Don't show snackbar for this specific error as it's handled by the UI
      } else if (errorMessage === "Whatsapp Service OFF") {
        dispatch(fetchContactListWhatsAppServiceOff());
        // Don't show snackbar for this specific error as it's handled by the UI
      } else {
        dispatch(fetchContactListFailed());
        dispatch(
          showMessage({
            type: "error",
            message: errorMessage || "Failed to fetch contacts",
            displayAs: "snackbar",
          })
        );
      }
    }
  };

export const CLEAR_CONTACT_STATE = "CLEAR_CONTACT_STATE";

export const clearContactState = () => action(CLEAR_CONTACT_STATE);

// Action events types
export const FETCH_ACTION_EVENT_PROGRESS = "FETCH_ACTION_EVENT_PROGRESS";
export const FETCH_ACTION_EVENT_SUCCESS = "FETCH_ACTION_EVENT_SUCCESS";
export const FETCH_ACTION_EVENT_FAILED = "FETCH_ACTION_EVENT_FAILED";

// Action creators
export const fetchActionEventProgress = () =>
  action(FETCH_ACTION_EVENT_PROGRESS);
export const fetchActionEventSuccess = (
  data: IActionEvent[],
  totalRecords: number
) =>
  action(FETCH_ACTION_EVENT_SUCCESS, {
    data,
    totalRecords,
  });
export const fetchActionEventFailed = () => action(FETCH_ACTION_EVENT_FAILED);

// Async Thunk for fetching action events
export const fetchActionEventAsync =
  (
    pageNumber: number = 1,
    rowsInPerPage: number = 10,
    conversation_id: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchActionEventProgress());

      let url = `/conversation/get-conversation-sentiment?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&mobile_no=${conversation_id}`;

      const res = await api.get(url);
      const data: IActionEvent[] = res.data.data || [];
      const totalRecords = res.data.totalRecords || data.length; // fallback if totalRecords not provided

      dispatch(fetchActionEventSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchActionEventFailed());
      dispatch(
        showMessage({
          type: "error",
          message:
            err.response?.data?.message || "Failed to fetch action events",
          displayAs: "snackbar",
        })
      );
    }
  };

export const CLEAR_ACTION_EVENT_STATE = "CLEAR_ACTION_EVENT_STATE";
export const clearActionEventState = () => action(CLEAR_ACTION_EVENT_STATE);
